import { render, staticRenderFns } from "./PowerGuard.vue?vue&type=template&id=4b243057&"
import script from "./PowerGuard.vue?vue&type=script&lang=js&"
export * from "./PowerGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports